import React from "react";
import Navbar from "../../components/navbar/navbar";
import job_interview from '../../assets/images/job_interview.png';
import { Link } from "react-router-dom";
import icon1 from './service_icons/icon1.png'
import icon2 from './service_icons/icon2.png'
import icon3 from './service_icons/icon3.png'
import icon4 from './service_icons/icon4.png'
function InvestmentProperties(){
    return(
        <>
        <Navbar/>
        <div data-aos="fade-in">
        <div className="services_banner services_banner1">
            <div>
                <h2>Investment Buying Services</h2>
                <p>
                    At Buyers Galaxy, we specialize in helping investors make smart, informed decisions when purchasing
                    property. Our Investment Buying Services are designed to leverage our extensive experience, industry
                    connections, and strategic insights to secure properties that provide long-term growth and generate
                    wealth.
                </p>
                <Link to="/contact" className="btn">Contact Us</Link>
            </div>
        </div>
        <div className="service_offer">
            <h2 className="offer">What We Offer</h2>
            <div className="offer_blocks">
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon1} alt="" />
                    </div>
                    <div>
                        <h5>Tailored Investment Strategies</h5>
                        <p>With expertise in real estate, we tailor strategies for capital growth, rental yield, or portfolio diversification.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon2} alt="" />
                    </div>
                    <div>
                        <h5>In-Depth Market Knowledge</h5>
                        <p>Our deep knowledge of Melbourne's property market offers the latest trends, insights, and opportunities to help maximize your ROI.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon3} alt="" />
                    </div>
                    <div>
                        <h5>Strategic Property Selection</h5>
                        <p>We assess each property's growth potential, focusing on location, infrastructure, and demand for maximum future
                        value.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon4} alt="" />
                    </div>
                    <div>
                        <h5>Industry Connections</h5>
                        <p>We leverage our network to access off-market deals and exclusive investment opportunities unavailable to others.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
            </div>
        </div>
        <div className="services_info_bottom">
            <p>Discover Melbourne's no-go suburbs for Investment</p>
            <Link to='/download'>Download Now</Link>
        </div>
        <div className="services_info">
            <div className="service_img_detail">
                <h2>Why Choose Us?</h2>
                <p>
                    Our deep industry experience gives us a unique advantage in identifying properties 
                    that aren’t just homes, but investments that will generate wealth for you. With a 
                    focus on maximizing capital growth and rental yield, our approach ensures that your 
                    portfolio is positioned for long-term success.
                </p>
                <p>
                    With Buyers Galaxy, you benefit from a team that understands the nuances of the market, 
                    has the connections to unlock exclusive deals, and uses proven strategies to make your 
                    investments work harder for you.
                </p>
                <p>
                    Let us help you build a property portfolio that grows with your wealth aspirations.
                </p>
                {/* <Link to="/contact" className="con-btn">Get a House Now</Link> */}
            </div>
            <img src={job_interview} alt="" />
        </div>
        <div className="services_details"></div>
        </div>
        </>
    );

}
export default InvestmentProperties;